define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var Page = require("ui.components/page/Page");

    var SecureUtilities = require("infra-util/SecureUtilities");
    var UsersFooterView = require("user-management-views/users/UsersFooterView");
    var UserModel = require("models/entities/UserModel");
    var UserEditView = require("user-management-views/users/UserEditView");
    var Config = require("user-management-assets/config/config.json");
    var ValidationUtilities = require("utils/ValidationUtilities");
    var SettingsCollection = require("collections/SettingsCollection");

    var UserEditController = {};

    var PICTURE_URL_ERRORS = {
        INVALID_URL: "invalidUrl",
        UNSUPPORTED_PICTURE_FORMAT:"unsupportedPictureFormat"
    };

    var URL_EXTENSIONS = ["PNG", "GIF", "JPEG", "JPG"];

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        UserEditController = Marionette.Controller.extend({
            pageView: null,
            insideView: null,
            userModel: null,
            isMyUser: false,
            isModelChanged: false,
            rootGroup: null,
            initialize: function (options) {
                this._initialize(options);
            },

            getView: function () {
                return this._getView();
            },
            showUserEdit: function (userId) {
                this._showUserEdit(userId);
            },

            _initialize: function(options) {
                LEUserManagement.logger.info("initializing", "UserEditController:initialize");
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.USER_EDIT);
                this._bindEvents();
            },
            _bindEvents: function() {
                this.listenTo(this.channel.vent, "user:change:loginName", this._onLoginNameChange);
                this.listenTo(this.channel.vent, "user:change:email", this._onEmailChange);
                this.listenTo(this.channel.vent, "user:change:nickName", this._onNickNameChange);
                this.listenTo(this.channel.vent, "user:change:displayName", this._onDisplayNameChange);
                this.listenTo(this.channel.vent, "user:change:employeeId", this._onEmployeeIdChange);
                this.listenTo(this.channel.vent, "user:change:permissionGroup", this._onPermissionGroupChange);
                this.listenTo(this.channel.vent, "user:change:skills", this._onSkillsChange);
                this.listenTo(this.channel.vent, "user:skill:create", this._onSkillCreate);
                this.listenTo(this.channel.vent, "user:change:maxNumberOfChats", this._onMaxNumberOfChatsChange);
                this.listenTo(this.channel.vent, "user:change:maxConversations", this._onMaxConversationsChange);
                this.listenTo(this.channel.vent, "user:change:enabled", this._onEnabledChange);
                this.listenTo(this.channel.vent, "user:change:oldPassword", this._onOldPasswordChange);
                this.listenTo(this.channel.vent, "user:change:password", this._onPasswordChange);
                this.listenTo(this.channel.vent, "user:cancel", this._onCancel);
                this.listenTo(this.channel.vent, "user:save", this._validateBeforeSave);
                this.listenTo(this.channel.vent, "user:setMemberAndManagerOfField", this._memberAndManagerOfFieldStatus);
                this.listenTo(this.channel.vent, "user:change:memberSingleSelect", this._onMemberOfChange);
                this.listenTo(this.channel.vent, "user:change:managerOfGroups", this._onManagerOfChange);
                this.listenTo(this.channel.vent, "user:change:managerOfGroups", this._onManagerOfChange);
                this.listenTo(this.channel.vent, "user:blur:pictureUrl", this._handlePictureUrl);
                this.listenTo(this.channel.vent, "user:change:pictureUrl", this._onPictureUrlChange);
                this.listenTo(this.channel.vent, "user:change:changePasswordNextLogin", this._onChangePasswordNextLoginChange);
            },
            _getView: function() {
                this._initPageView();
                return this.pageView;
            },
            _initPageView: function() {
                if (this.pageView) {
                    this.pageView.close();
                }
                this.pageView = new Page({
                    moduleName: LEUserManagement.moduleName,
                    context: LE.context,
                    permutation: Page.PERMUTATION.Standard,
                    contentWidth: Page.CONTENT_WIDTH.Medium,
                    footer: new UsersFooterView()
                });
            },
            _showUserEdit: function(userId) {
                LEUserManagement.logger.info("show user edit view", "UserEditController:_showUserEdit", userId);
                this.isModelChanged = false;
                this.isMyUser = (userId === LE.sessionManager.getUserId());
                this.rootGroup = this._getRootGroup();
                if (userId === CONST.ROUTING.NEW_ITEM_ID) {
                    this._closeLayoutLoader();
                    this._createNewUser();
                }
                else {
                    this._fetchUser(userId);
                }
            },
            _createNewUser: function() {
                this.userModel = new UserModel();
                this.userModel.setPermissionGroup(0); /* TODO: COMPLETE WITH THE WANTED PERMISSION GROUP */
                if (!this._hasGroupStructure()) {
                    this.userModel.setManagerOf([this.rootGroup]);
                    this.userModel.setMemberOfGroup(this.rootGroup);
                }
                this._fetchSiteSettingsData();
            },
            _fetchUser: function(userId) {
                this.userModel = new UserModel({id:userId}, {isMyUser:this.isMyUser});
                this._showLoader();
                this.userModel.fetch({
                    success: _.bind(this._onFetchUserSuccess, this),
                    error:  _.bind(this._onFetchUserError, this)
                });
            },

            /*
            Fetch data from SiteSettings
             */
            _fetchSiteSettingsData: function() {
                if(this._isACUserMessagingState()) {
                    this._fetchMaxConversations();
                } else {
                    this._closeLayoutLoader();
                    this._showView();
                }
            },

            _onFetchUserSuccess: function(model, response, options) {
                LEUserManagement.logger.debug("fetch user success", "UserEditController:_onFetchUserSuccess", response);
                this._fetchSiteSettingsData();
            },
            _onFetchUserError: function(model, response, options) {
                LEUserManagement.logger.debug("fetch user error closing loader returning to list", "UserEditController:_onFetchUserError", response);
                this._closeLayoutLoader();
                LEUserManagement.notifier.showError({content:LE.translator.translate("LEUserManagement.userEdit.errorOnFetching.text"), timeToShow: 6000});
                this._navigateToUserList();
            },
            _fetchMaxConversations: function() {
                this.settingsCollection = new SettingsCollection([], {contextType: SettingsCollection.SETTINGS_ENUM.CONTEXT_TYPE.ACCOUNT, contextCascading: true});

                this.settingsCollection.fetch({
                    settingsIds: [SettingsCollection.SETTINGS_ENUM.SETTING_ID.MAX_CONVERSATIONS],
                    success: _.bind(this._onSettingsFetchSuccess, this),
                    error: _.bind(this._onSettingsFetchError, this)
                });
            },
            _onSettingsFetchSuccess: function() {
                LEUserManagement.logger.debug("fetch settings success", "UserEditController:_onSettingsFetchSuccess");
                this.maxConversationsSettings = this.settingsCollection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.MAX_CONVERSATIONS).getValue();
                this._closeLayoutLoader();
                this._showView();
            },
            _onSettingsFetchError: function() {
                LEUserManagement.logger.debug("fetch user error closing loader returning to list", "UserEditController:_onFetchUserError");
                this._closeLayoutLoader();
                LEUserManagement.notifier.showError({content:LE.translator.translate("LEUserManagement.userEdit.errorOnFetching.text"), timeToShow: 6000});
                this._navigateToUserList();
            },

            _showView: function() {
                LEUserManagement.logger.debug("show the user edit view in the page", "UserEditController:_showView");
                var title = (this.userModel.isNew()) ? LE.translator.translate("LEUserManagement.userEdit.header.title.new") : LE.translator.translate("LEUserManagement.userEdit.header.title.edit");
                var options = this._memberAndManagerOfFieldStatus();
                var employeeIdStatus = this._employeeIdStatus();
                this.insideView = new UserEditView({
                    model: this.userModel,
                    isMyUser: this.isMyUser,
                    "memberAndManagerOfStatus": options,
                    "employeeIdStatus": employeeIdStatus,
                    "showMaxConversations": this._isACUserMessagingState(),
                    "maxConversationsSettings": this.maxConversationsSettings
                });
                this.pageView.setTitle(title);
                this.pageView.setDescription(LE.translator.translate("LEUserManagement.userEdit.header.description"));
                this.pageView.setInsideView(this.insideView);
                this.originalMaxNumberOfChats = this.userModel.getMaxNumberOfChats();
                this.originalPermissionGroup = this.userModel.getPermissionGroup();
                this.originalMemberOfGroup = this.userModel.getMemberOfGroup();
            },

            _employeeIdStatus: function () {
                return this.userModel.getIsLegacy();
            },

            _getPermissionGroupText: function(pgid) {
                if (pgid >=0) {
                    var pgName;
                    _.each(LEUserManagement.getDataManager().getPermissionGroupsCollection().models, function(pg) {
                        if (pg.get("id") === pgid.toString()){
                            pgName =  pg.get("name");
                            return;
                        }
                    });
                    return pgName;
                }
            },

            _isAgent: function(maxChatsval, permissionGroupVal) {//todo: isAgent should be moved to UserModel
                var maxChats = maxChatsval || this.userModel.getMaxNumberOfChats();
                var permissionGroup;
                if (!_.isNull(permissionGroupVal) && !_.isUndefined(permissionGroupVal)){
                    permissionGroup = permissionGroupVal;
                } else {
                    permissionGroup = this.userModel.getPermissionGroup();
                }

                return maxChats > 0 || maxChats === "Unlimited" || this._getPermissionGroupText(permissionGroup) === CONST.USER_PERMISSION_GROUP.AGENT;
            },

            _isChangedToNonManager: function() {
                return !this._isManager() && this._isManager(this.originalPermissionGroup);
            },

            _isChangedToNonAgent: function() {
                return !this._isAgent() && this._isAgent(this.originalMaxNumberOfChats, this.originalPermissionGroup);
            },

            _isManager: function(permissionGroupVal) {
                var permissionGroup;
                if (!_.isNull(permissionGroupVal) && !_.isUndefined(permissionGroupVal)){
                    permissionGroup = permissionGroupVal;
                } else {
                    permissionGroup = this.userModel.getPermissionGroup();
                }
                return this._getPermissionGroupText(permissionGroup) === CONST.USER_PERMISSION_GROUP.ADMINISTRATOR || this._getPermissionGroupText(permissionGroup) === CONST.USER_PERMISSION_GROUP.AGENT_MANAGER;
            },

            _hasGroupStructure: function() {
                return LE.siteSettings.accountSettings.isAcUser() && LE.sessionManager.hasAgentGroupsFeature() && LEUserManagement.getDataManager().getAgentGroupsCollection().length > 1;
            },

            _memberAndManagerOfFieldStatus: function() {
                var isAgent, isManager;
                var options = {"showMemberField": false, "showManagerOfField": false};
                var hasGroupStructure = this._hasGroupStructure();
                if (hasGroupStructure) {
                    isAgent = this._isAgent();
                    this.userModel.setAgentStatus(isAgent);
                    isManager = this._isManager();
                }
                if (hasGroupStructure && isAgent) {
                   options.showMemberField = true;
                }

                if (hasGroupStructure && isManager) {
                    options.showManagerOfField = true;
                }

                return options;

            },

            _getRootGroup: function() {
                var rootGroup;
                _.all(LEUserManagement.getDataManager().getAgentGroupsCollection().models, function(group) {
                    if (group.get("parentGroupId") === null) {
                        rootGroup = group.get("id");
                        return false;
                    } else {
                        return true;
                    }
                });
                return rootGroup;
            },

            _onLoginNameChange: function(loginName) {
                this.userModel.setLoginName(loginName.trim());
            },

            _onEmailChange: function(email) {
                this.userModel.setEmail(email);
            },

            _onNickNameChange: function(nickName) {
                this.userModel.setNickName(nickName);
            },

            _onDisplayNameChange: function(displayName) {
                this.userModel.setDisplayName(displayName);
            },

            _onEmployeeIdChange: function(employeeId) {
                this.userModel.setEmployeeId(employeeId);
            },

            _handlePictureUrl: function(options) {
                options = options || {};
                var pictureUrl = options.value || "";
                var isValidated = this.userModel.getPictureUrlValidated();
                var hasErrors = this.userModel.getPictureUrlErrors();
                if (pictureUrl !== "") {
                    this._setInvalidListener();
                    if (options.origin === "fieldBlur") {
                        if (!isValidated){
                            this.userModel.setPictureUrlValidated(true);
                            var errorsObj = this._pictureUrlValidation(pictureUrl);
                            if (!_.isEmpty(errorsObj)) {
                                this._setPreviewPicture(this.insideView.URLS.AVATAR_PICTURE);
                                this.userModel.trigger("invalid", this.userModel, errorsObj);
                            } else {
                                this._setPreviewPicture(pictureUrl);
                            }
                        }
                    }
                    if (options.origin === "save") {
                        if (isValidated && !hasErrors) {
                            return true;
                        } else if (!isValidated || hasErrors) {
                            this.userModel.setPictureUrlValidated(true);
                            return this._pictureUrlValidation(pictureUrl);
                        }
                    }
                } else {
                    this._setPreviewPicture(this.insideView.URLS.AVATAR_PICTURE);
                }
            },

            _pictureUrlValidation: function(pictureUrl) {
                var errorsObj = {};
                var isHttps = pictureUrl.indexOf("https://") === 0;
                var hasPictureExtension = this._hasPictureExtension(pictureUrl);
                var isUrl = this._isUrl(pictureUrl);
                if (!isHttps || !isUrl) {
                    this.userModel.setPictureUrlErrors(true);
                    errorsObj[PICTURE_URL_ERRORS.INVALID_URL] = "LEUserManagement.userEdit.error.pictureURL.url.invalid";
                } else if (!hasPictureExtension) {
                    this.userModel.setPictureUrlErrors(true);
                    errorsObj[PICTURE_URL_ERRORS.UNSUPPORTED_PICTURE_FORMAT] = "LEUserManagement.userEdit.error.pictureURL.unsupported.picture.format";
                }
                return errorsObj;

            },

            _hasPictureExtension: function(obj) {
                var ext = obj.substr(obj.lastIndexOf('.')+1);
                if (ext) {
                    for (var ii=0; ii < URL_EXTENSIONS.length; ii++){
                        if (ext.toLowerCase() === URL_EXTENSIONS[ii].toLowerCase()) {
                            return true;
                        }
                    }
                }
                return false;
            },

            _isUrl: function(obj) {
                return ValidationUtilities.isValid(obj, Config.validators.uri.regex);
            },

            _onPermissionGroupChange: function(permissionGroup) {
                var isAgent = this._isAgent(null, permissionGroup);
                var isManager = this._isManager(permissionGroup);
                this.userModel.setAgentStatus(isAgent);
                this.userModel.setPermissionGroup(permissionGroup.toString());
                var hasGroupStructure = this._hasGroupStructure();
                if (hasGroupStructure) {
                    this.insideView.manageMemberOfFieldStatus(isAgent);
                    this.insideView.manageManagerOfFieldStatus(isManager);
                } else {
                    if (isAgent) {
                        this.userModel.setMemberOfGroup(this.rootGroup);
                    }
                    if (isManager) {
                        this.userModel.setManagerOf([this.rootGroup]);
                    }
                }
            },

            _onSkillsChange: function(skills) {
                this.userModel.setSkills(skills);
            },

            _onMemberOfChange: function(groupId) {
                this.userModel.setMemberOfGroup(groupId);
            },

            _onManagerOfChange: function() {
                var managerOf = this.insideView.uiComponents.manageGroups.getSelectedItems();
                this.userModel.setManagerOf(managerOf);
            },

            _onPictureUrlChange: function() {
                var url = this.insideView.uiComponents.pictureUrl.getValue();
                if (url === null || typeof url === "undefined") {
                  url = this.userModel.getPictureUrl();
                }
                if (url !== this.userModel.getPictureUrl()){
                    this.userModel.setPictureUrl(url);
                    this.userModel.setPictureUrlValidated(false);
                    this.userModel.setPictureUrlErrors(false);
                }
            },

            _onSkillCreate: function(skillName) {
                this._showLoader();

                var skillCollection = LEUserManagement.getDataManager().getSkillsCollection();
                var skillObject = {name: skillName, description:skillName};

                /********************************************************/
                /*  TODO: Tomer: The skill creation should be done with the collection.create but since the SKILLS API is in APP SERVER it's not supported.
                    The app server response is nothing instead of the new model so we dont know what is the new ID of the model.
                    The create method "options" object doesn't include the xhr (in opposite to save method) so we cannot use the create and we must use the regular save
                 */
                /********************************************************/
                /*
                skillCollection.create(skillObject, {
                    validate: true,
                    wait: true,
                    success: _.bind(this._onSkillCreateSuccess, this),
                    error: _.bind(this._onSkillCreateError, this)
                });
                */

                var SkillModel = skillCollection.model;
                var skillModel = new SkillModel(skillObject);
                skillModel.save(null, {
                    success: _.bind(this._onSkillCreateSuccess, this),
                    error: _.bind(this._onSkillCreateError, this)
                });
            },

            _onSkillCreateSuccess: function(model, resp, options) {
                /********************************************************/
                /* TODO: Tomer: This is definitely a HACK!!! It's done because the appserver's response doesnt include the new model (only the sent object).
                We should understand what is the ID from the response header BAHH :(
                */
                var id = options.xhr.getResponseHeader("location").split("skills/")[1];
                id = parseInt(id, 10);
                model.set("id", id);
                /********************************************************/
                LEUserManagement.getDataManager().updateCollection(model);
                this.channel.trigger("user:skill:create:success", model);
                this._closeLoader();
            },

            _onSkillCreateError: function(model, resp, options) {
                this._closeLoader();

                var errorObject = {};
                var defaultMessage = LE.translator.translate("LEFramework.something.went.wrong");

                if (resp && resp.responseError && resp.responseError.error && resp.responseError.error.message) {
                    defaultMessage = resp.responseError.error.message;

                    if (_.include(resp.responseError.error.message, ErrorCodes.appServer.messages.duplicateEntity)) {
                        errorObject[model.KEYS.NAME] = LE.translator.translate("LEFramework.entities.skill.errors.name.duplicated");
                    }
                }

                var messageToShow = (!_.isEmpty(errorObject)) ? LEUserManagement.getGeneralErrorMsg(errorObject) : defaultMessage;
                if (!_.isEmpty(messageToShow)) {
                    LEUserManagement.notifier.showError(messageToShow);
                }

                this.channel.trigger("user:skill:create:error", errorObject);
            },

            _onMaxNumberOfChatsChange: function(maxNumberOfChats) {
                var isAgent = this._isAgent(maxNumberOfChats);
                this.userModel.setAgentStatus(isAgent);
                this.userModel.setMaxNumberOfChats(maxNumberOfChats);
                var hasGroupStructure = this._hasGroupStructure();

                if (hasGroupStructure) {
                    this.insideView.manageMemberOfFieldStatus(isAgent);
                } else {
                    if (isAgent) {
                        this.userModel.setMemberOfGroup(this.rootGroup);
                    }
                }
            },

            _onMaxConversationsChange: function(maxConversations) {
                this.userModel.setMaxConversations(maxConversations);
            },

            _onEnabledChange: function(enabled) {
                this.userModel.setEnabled(enabled);
            },

            _onOldPasswordChange: function(oldPassword) {
                this.userModel.setOldPassword(oldPassword);
            },

            _onPasswordChange: function(password) {
                this.userModel.setPassword(password);
            },

            _onChangePasswordNextLoginChange: function(changePwdNextLogin) {
                this.userModel.setChangePasswordNextLogin(changePwdNextLogin);
            },

            _onCancel: function() {
                LEUserManagement.logger.info("cancel the user edit", "UserEditController:_onCancel");

                this._navigateToUserList();
            },

            _validateBeforeSave: function() {
                this._setInvalidListener();
                var runSave = false;
                var pictureUrlValue = this.insideView.uiComponents.pictureUrl.getValue();
                if (pictureUrlValue !== ""){
                    runSave = this._handlePictureUrl({origin:"save", value: pictureUrlValue});
                    if (runSave) {
                        this._onSave(runSave);
                    }
                } else {
                    this.userModel.setPictureUrl(null);
                    this._onSave();
                }
            },

            _onSave: function(errors) {
                if (!errors) {
                    errors = {};
                }
                LEUserManagement.logger.info("save the user", "UserEditController:_onSave", this.userModel);

                var validateViewErrors = this.insideView.validateView();
                var validateModelErrors = this.userModel.validate();
                var validateErrors = _.extend({}, validateViewErrors, validateModelErrors, errors);

                if (_.isEmpty(validateErrors)) {
                    if (this._shouldShowConfirmationMessage()) {
                        var message = this._getOnSaveConfirmationMessage();//TODO message will be undefined after rollback with assign users with agent groups
                            LEUserManagement.notifier.showConfirm({
                                title: LE.translator.translate("LEFramework.global.captions.are.you.sure"),
                                content: message,
                                objectAction: {
                                    text: LE.translator.translate("LEFramework.global.captions.yes"),
                                    callback: _.bind(this._onSaveConfirmed, this)
                                }
                            });
                    } else {
                        this._onSaveConfirmed();
                    }
                }
                else {
                    this._setPreviewPicture(this.insideView.URLS.AVATAR_PICTURE);
                    this.userModel.trigger("invalid", this.userModel, validateErrors);
                }
            },

            _setPreviewPicture: function(url) {
                this.insideView.ui.picturePreview.attr("src", url);
            },

            _getOnSaveConfirmationMessage: function() {
                var message;
                var agentName = SecureUtilities.escapeForHtmlContent(this.userModel.getDisplayName());

                if (this._isChangedToNonManager() && !this._isChangedToNonAgent()) {
                    var permissionGroupNameValue = LEUserManagement.getDataManager().getPermissionGroupNameById(this.userModel.getPermissionGroup());
                    message = this._substituteParamsAndTranslate("LEUserManagement.userEdit.manageGroups.removal.confirm.text", permissionGroupNameValue, agentName);
                } else {
                    var assignedAgentGroupId = this.userModel.getMemberOfGroup() || this.originalMemberOfGroup;
                    if(LEUserManagement.getDataManager().getAgentGroupsCollection().get(assignedAgentGroupId)) {
                        var assignedAgentGroupName = SecureUtilities.escapeForHtmlContent(LEUserManagement.getDataManager().getAgentGroupsCollection().get(assignedAgentGroupId).getName());
                        if (this._isChangedToNonManager() && this._isChangedToNonAgent()) {
                            message = this._substituteParamsAndTranslate("LEUserManagement.userEdit.manageGroups.assignedToGroup.removal.confirm.text", agentName, assignedAgentGroupName);
                        } else {
                            message = this._substituteParamsAndTranslate("LEUserManagement.userEdit.assignedToGroup.removal.confirm.text", agentName, assignedAgentGroupName);
                        }
                    } else {
                        LEUserManagement.logger.error("assignedAgentGroupId not found in agent group list.", "UserEditController:_getOnSaveConfirmationMessage", this.userModel);
                        LEUserManagement.logger.graph({name: "userManagement:UserEditController:_getOnSaveConfirmationMessage:assignedAgentGroupIdNotFound" });
                    }
                }
                return message;
            },

            _substituteParamsAndTranslate: function(translationKey, substitute1, substitute2) {
                return LE.translator.translate({
                    key: translationKey,
                    args: [{key: substitute1, isTranslate: false},{key: substitute2, isTranslate: false}]
                });
            },

            _shouldShowConfirmationMessage: function() {
                return (this._isChangedToNonManager() || this._isChangedToNonAgent()) && !this.userModel.isNew() && this._hasGroupStructure() ;
            },

            _fixAgentGroupData: function () {
                var memberOfIsHidden = false;
                var managerOfIsHidden = false;

                if (this.insideView.ui.memberOfSelectContainer.hasClass("hide")) {
                    memberOfIsHidden = true;
                }
                if (this.insideView.ui.managerOfSelectContainer.hasClass("hide")) {
                    managerOfIsHidden = true;
                }

                if (this._hasGroupStructure()) {
                    if (memberOfIsHidden) {
                        this.userModel.setMemberOfGroup(null);
                    }
                    if (managerOfIsHidden) {
                        this.userModel.setManagerOf([]);
                    }
                } else {
                    if (!this._isManager()) {
                        this.userModel.setManagerOf([]);
                    }
                    if (!this._isAgent()) {
                        this.userModel.setMemberOfGroup(null);
                    }
                }
            },

            _onSaveConfirmed: function() {
                this._showLoader();

                this._fixAgentGroupData();

                this.userModel.save(null, {
                    isMyUser: this.isMyUser,
                    ignoreError: true,
                    success: _.bind(this._onSaveSuccess, this),
                    error: _.bind(this._onSaveError, this)
                });
            },

            _onSaveSuccess: function(model, resp, options) {
                LEUserManagement.logger.debug("user saved successfully", "UserEditController:_onSaveSuccess", model);
                this.userModel.setPictureUrlValidated(false);
                this.userModel.setPictureUrlErrors(false);
                this._afterSave();
                if (this.isMyUser) {
                    LE.context.set("user.name", this.userModel.getDisplayName());
                    LE.context.set("user.nickName", this.userModel.getNickName());
                }
                LEUserManagement.getDataManager().updateCollection(model);
                this.userModel.setPictureUrlValidated(false);
                this.userModel.setPictureUrlErrors(false);
                this._navigateToUserList();
            },

            _onSaveError: function(model, resp, options) {
                LEUserManagement.logger.error("User could not be saved", "UserEditController:_onSaveError", model);
                this._afterSave();
                var errorMessage = LE.translator.translate("LEFramework.something.went.wrong");
                errorMessage = options.errorMessage?options.errorMessage:errorMessage;

                if (resp && resp.responseError && resp.responseError.internalCode) {
                    if (ErrorCodes.concurrentModificationConflict === resp.responseError.internalCode) {
                        errorMessage = LE.translator.translate("LEFramework.entities.user.errors.outdated.revision.error");
                    } else if (ErrorCodes.noDataFound === resp.responseError.internalCode) {
                        errorMessage = LE.translator.translate("LEFramework.entities.user.errors.entity.was.deleted");
                        this._onCancel();
                    }
                }

                var messageToShow = (!_.isEmpty(options.errorObject)) ? LEUserManagement.getGeneralErrorMsg(options.errorObject) : errorMessage;
                if (!_.isEmpty(messageToShow)) {
                    LEUserManagement.notifier.showError(messageToShow);
                }
                if((!_.isEmpty(options.errorObject))) {
                    this.channel.trigger("user:save:error", options.errorObject);
                }
            },

            _onInvalidError: function(model, errorObject) {
                LEUserManagement.logger.error("user could not be saved (client)", "UserEditController:_onInvalidError", model);

                this._afterSave();

                var translatedErrorObj = {};
                _.each(errorObject, function (value, key, obj) {
                    translatedErrorObj[key] = LE.translator.translate(value);
                });

                LEUserManagement.notifier.showError(LEUserManagement.getGeneralErrorMsg(translatedErrorObj));
                this.channel.trigger("user:save:error", translatedErrorObj);
            },

            _setInvalidListener: function() {
                this.listenTo(this.userModel, "invalid", this._onInvalidError);
            },

            _afterSave: function() {
                this._stopInvalidListener();
                this._closeLoader();
            },

            _stopInvalidListener: function() {
                this.stopListening(this.userModel, "invalid");
            },

            _showLoader: function() {
                LEUserManagement.showLoader();
            },

            _closeLoader: function() {
                LEUserManagement.closeLoader();
            },

            _closeLayoutLoader: function() {
                LEUserManagement.closeLoader();
            },

            _navigateToUserList: function() {
                LEUserManagement.logger.debug("navigate to user list", "UserEditController:_navigateToUserList");
                LEUserManagement.router.navigate("users");
            },

            _isACUserMessagingState: function() {
                return LE.siteSettings.accountSettings.isAcUser() && LE.sessionManager.hasAsyncMessagingFeature();
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return  UserEditController;
});
